import ServiceOutline from '@pages/Beneficiary-block/WomenComponent/ANC/CommonOutline/AddServiceOutline';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@store/reducers';
import AlertPopup from '../../CreateNewChild/AlertPopup';
import { getData, getDataWithCache, postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { getServiceDetailsUnderCurrentDate } from '@services/ancApiServices';
import { updateAncService } from '@store/actions/beneficiaryAction';
import './ChildHbyc.css';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import { child_hbyc_message, HBYC_COMMON_CONSTANTS } from '@constants/ChildHbycConstant';
import { areDatesSame, feildValidation, isServiceThroughSession } from '@utils/commonUtils';
import {
  CHILD_DETAILS,
  childData,
  childObj,
  getHbycTitle,
  getOngoingHBYCDetails,
  hbyc2Data,
  hbyc2Obj,
  hbyc3Data,
  hbyc3Obj,
  hbyc4Data,
  hbyc4Obj,
  HBYC_API_DETAILS,
  hbycKey,
  IS_TESTED_FOR_HIV_OPTIONS,
  SYPHILIS_TEST_OPTIONS,
} from '../ChildtrackingConstant';
import FormatDate from '@utils/dateFormat';
import dayjs from 'dayjs';
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import { checkIsDigit } from '@utils/commonUtils';
import { color_codes } from '@constants/appConstants';
import { fetchWeightForLengthData } from '@services/childApiServices';
import { useLocation } from 'react-router-dom';
import Spinner from '@components/common/Spinner';
interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  reportId?: any;
  serviceId?: any;
  code?: any;
  option?: any;
}
export interface formStateType {
  [key: string]: objectType;
}

const ChildHbyc = () => {
  const childHybcObj: any = {};
  const childHbycData:any = {};
  const breadcrumbItemName = [{ value: 'beneficiary', label: 'HBYC' }];
  const location=useLocation();
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>([false]);
  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [loader, setLoader] = useState<boolean>(false);
  const dispatch = useDispatch();
  const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails,);
  const viewEditMetaData = useSelector((state: RootState) => state.beneficiary.viewEditMetaData,);
  const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails,);
  const isEditButtonClicked = useSelector((state: RootState) => state.beneficiary.isEditButtonClicked);
  const isHBYCSameDay = useSelector((state: RootState) => state.beneficiary.isHBYCSameDay);
  const navigateWithMenuItem = useNavigateWithMenuItem();
  const visitDateUsed = currentFacilityDetails?.visitDate || location?.state?.serviceDetails?.visit_date || viewEditMetaData?.ancVisitDate;
  const hbycOngoingMetaData = getOngoingHBYCDetails(childDetails?.dob, visitDateUsed);
  const [motherSyphilisTest, setMotherSyphilisTest] = useState<string | null>(null);
  const [currentHivTest, setCurrentHivTest] = useState<string | null>(null);
  const [whoGrowthData, setWhoGrowthData] = useState<any>(null);
  if(hbycOngoingMetaData[0]?.hbyc === 1) {
    Object.assign(childHybcObj, { ...childObj,  syphilisTest: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    nacpRefferalFacility: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      serviceId: '',
      reportId: '',
    },
  })
    Object.assign(childHbycData, { ...childData, syphilisTest: {
      '#type': 'select',
      '#title': 'Syphilis Test',
      '#webform_key': 'syphilisTest',
      '#options': [],
      '#isDisabled':false,
      '#required': true,
    },
    nacpRefferalFacility: {
      '#type': 'select',
      '#title': 'Referred to NACP referral facility',
      '#webform_key': 'nacpRefferalFacility',
      '#options': [],
      '#isDisabled':true,
      '#required': false,
    },
  })
  } else if(hbycOngoingMetaData[0]?.hbyc === 2) {
    Object.assign(childHybcObj, {
      ...childObj,
      ...hbyc2Obj
    })
    Object.assign(childHbycData, {
      ...childData,
      ...hbyc2Data
    })
  } else if(hbycOngoingMetaData[0]?.hbyc === 3) {
    Object.assign(childHybcObj, {
      ...childObj,
      ...hbyc3Obj,
    })
    Object.assign(childHbycData, {
      ...childData,
      ...hbyc3Data
    })
  } else if(hbycOngoingMetaData[0]?.hbyc === 4) {
    Object.assign(childHybcObj, {
      ...childObj,
      ...hbyc4Obj
    })
    Object.assign(childHbycData, {
      ...childData,
      ...hbyc4Data
    })
  } else {
    Object.assign(childHybcObj, {
      ...childObj,
      ...hbyc4Obj
    })
    Object.assign(childHbycData, {
      ...childData,
      ...hbyc4Data
    })
  }

  const [actionSource, setActionSource] = useState('');
  const [weightOfBabyServiceId, setWeightOfBabyServiceId] = useState<any>('');
  const [lengthOfBabyServiceId, setLengthOfBabyServiceId] = useState<any>('');
  const eventExution = useSelector((state: RootState) => state.eventExution);
  const [childHbycFormState, setChildHbycFormState] = useState<formStateType>(childHybcObj);
  const [childHbycFormData, setChildHbycFormData] = useState<any>(childHbycData);
  const [backDatedResponse, setBackDatedResponse] = useState<any>([]);
  const [backDatedFormDetails, setBackDatedFormDetails] = useState<any>(childHybcObj);

  const vhndDetails = isServiceThroughSession(eventExution);

  const getBackDatedEntry = async () => {
    try {
      setLoader(true);
      if (isEditButtonClicked && viewEditMetaData?.serviceVisitId) {
        const VisitServiceResponse = await getData<any>(`${endpoints.getCompletedHbycServiceListByVisitService}/${viewEditMetaData.serviceVisitId}`);
        const childGrowthInfoPayload = {
          serviceVisitId: viewEditMetaData.serviceVisitId,
          partitionKeyTrxnDate: viewEditMetaData.ancVisitDate
        };
        const childGrowthInfo = await postDataJSON<any>(`${endpoints.childGrowthInfo}`, childGrowthInfoPayload);
        if (VisitServiceResponse) {
          constructAndSetBackDatedData(VisitServiceResponse?.data, childGrowthInfo?.data, true);
          setBackDatedResponse(VisitServiceResponse?.data);
        }
      } else {
        const serviceRes = await getServiceDetailsUnderCurrentDate('hbyc', childDetails?.benef_id || '', '', hbycOngoingMetaData[0]?.hbyc || 0, '');
        if (serviceRes?.data?.length > 0) {
          const latestServiceData = serviceRes.data.reduce((latest: any, current: any) => {
            if (!latest) return current;
            return dayjs(current.partition_key_trxn_date).isAfter(dayjs(latest.partition_key_trxn_date))
              ? current : latest;
          }, null);
          const partitionKeyTransactionDate = FormatDate(latestServiceData?.partition_key_trxn_date);
          const VisitServiceResponse = await getData<any>(`${endpoints.getCompletedHbycServiceListByVisitService}/${latestServiceData?.benef_service_visit_id}`);
          const childGrowthInfoPayload = {
            serviceVisitId: latestServiceData?.benef_service_visit_id,
            partitionKeyTrxnDate: partitionKeyTransactionDate
          };
          const childGrowthInfo = await postDataJSON<any>(`${endpoints.childGrowthInfo}`, childGrowthInfoPayload);
          if (VisitServiceResponse) {
            const isSameDateAsLastVisit = areDatesSame(visitDateUsed, latestServiceData?.partition_key_trxn_date, 'days');
            constructAndSetBackDatedData(VisitServiceResponse?.data, childGrowthInfo?.data, isSameDateAsLastVisit);
            setBackDatedResponse(VisitServiceResponse?.data);
          }
        }
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    } finally {
      setLoader(false);
    }
  }

  const initialFetch = async () => {
    try {
      setLoader(true);
      const whoData = await fetchWeightForLengthData();
      if (whoData) {
        setWhoGrowthData(whoData);
      }

      const hbycValue = hbycOngoingMetaData[0]?.hbyc;
      if (hbycValue === null || typeof hbycValue === 'undefined') {
        toast.error(`${child_hbyc_message.errorgetRedFlagIssueForBaby}`, { position: 'top-center' });
        return;
      }
      const redFlagIssueForBabyResponse = await getData<any[]>(`${endpoints.getRedFlagIssueForBaby}/${hbycValue}`,);
      const redFlagIssueForBabyOptions = redFlagIssueForBabyResponse?.data?.map(
        (item: any) => ({
          value: item.red_flag_issue_for_baby_name,
          label: item.red_flag_issue_for_baby_name,
          id: item.red_flag_issue_for_baby_id,
          code: item.red_flag_issue_for_baby_code,
        }),
      );

      const getColorZoneOfBabyResponse = await getDataWithCache<any[]>(`${endpoints.getColourZoneOfBaby}`,);
      const getColorZoneOfBabyOptions = getColorZoneOfBabyResponse?.data?.map(
        (item: any) => ({
          value: item.colour_zone_of_baby_name,
          label: item.colour_zone_of_baby_name,
          id: item.colour_zone_of_baby_id,
          code: item.colour_zone_of_baby_code,
        }),
      );
      const getMotherServiceData = await getData<any[]>(`${endpoints.getMotherServiceDetails}/${childDetails?.benef_id}`,);
        if (Array.isArray(getMotherServiceData?.data)) {
          const syphilis = getMotherServiceData.data.find(
            (item: any) => item.service_code === 'syphilis_test'
          );
          const hiv = getMotherServiceData.data.find(
            (item: any) => item.service_code === 'hiv_screening_test'
          );
          setMotherSyphilisTest(syphilis?.report_name ?? 'Non Reactive');
          setCurrentHivTest(hiv?.report_name ?? 'Non-Reactive');
          }

      const childWightResponse = await getDataWithCache<any[]>(`${endpoints.getServiceReportForChild}/${HBYC_API_DETAILS.WEIGHT_IN_KEY}`,);
      setWeightOfBabyServiceId(childWightResponse?.data[0]?.service_id);

      const childHeightResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportForChild}/${HBYC_API_DETAILS.HEIGHT_IN_KEY}`,
      );
      setLengthOfBabyServiceId(childHeightResponse?.data[0]?.service_id);

      const childIsSickResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHETHER_CHILD_IS_SICK_KEY}`,
      );
      const childIsSickOptions = childIsSickResponse?.data?.map((item: any) => ({
        value: item.report_name,
        label: item.report_name,
        id: item.service_id,
        reportId: item.report_id,
        code: item.report_code,
      }));

      const breastfeedingContinuedResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHETHER_EXCLUSIVE_BREASTFEEDING_CONTINUED_KEY}`,
      );
      const breastfeedingContinuedOptions = breastfeedingContinuedResponse?.data?.map((item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
      }));

      const syphilisTestResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.SYPHILIS_TEST_KEY}`,
      );
      const syphilisTestOptions = syphilisTestResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      syphilisTestOptions.push({
        value: "Not Done",
        label: "Not Done",
        id: null,
        reportId: null,
        code:null
      });


      const hivScreeningTestResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.HIV_TEST_KEY}`,
      );
      
      const hivScreeningOptions = hivScreeningTestResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      hivScreeningOptions.push({
        value: "Not Done",
        label: "Not Done",
        id: null,
        reportId: null,
        code:null
      });

      const nacpRefferalFacilityResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.NACP_REFERRAL_FACILITY}`,
      );
      
      const nacpRefferalFacilityOptions = nacpRefferalFacilityResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      const whetherOrsProvidedResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHETHER_ORS_PROVIDED_KEY}`,
      );
      const whetherOrsProvidedOptions = whetherOrsProvidedResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      const whetherComplementaryFeedingStartedResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_STARTED_KEY}`,
      );
      const whetherComplementaryFeedingStartedOptions = whetherComplementaryFeedingStartedResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      const whetherComplementaryFeedingAdequatelyProvidedResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED_KEY}`,
      );
      const whetherComplementaryFeedingAdequatelyProvidedOptions = whetherComplementaryFeedingAdequatelyProvidedResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      const whetherBottleOfIfaProvidedResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHEATER_BOTTLE_OF_IFA_PROVIDED_KEY}`,
      );
      const whetherBottleOfIfaProvidedOptions = whetherBottleOfIfaProvidedResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      const whetherchildreferredResponse = await getDataWithCache<any[]>(
        `${endpoints.getServiceReportByParams}/${HBYC_API_DETAILS.WHEATER_CHILD_REFERRED}`,
      );
      const whetherchildreferredOptions = whetherchildreferredResponse?.data?.map(
        (item: any) => ({
          value: item.report_name,
          label: item.report_name,
          id: item.service_id,
          reportId: item.report_id,
          code: item.report_code,
        }),
      );

      setChildHbycFormData((prevState: any) => ({
        ...prevState,
        redFlagSign: {
          ...prevState.redFlagSign,
          '#options': redFlagIssueForBabyOptions,
        },
        growthChartOfMcpCard: {
          ...prevState.growthChartOfMcpCard,
          '#options': getColorZoneOfBabyOptions,
        },
        weatherChildIsSick: {
          ...prevState.weatherChildIsSick,
          '#options': childIsSickOptions,
        },
        breastfeedingContinue: {
          ...prevState.breastfeedingContinue,
          '#options': breastfeedingContinuedOptions,
        },
        syphilisTest: {
          ...prevState.syphilisTest,
          '#options': syphilisTestOptions,
        },
        whetherOrsProvided: {
          ...prevState.whetherOrsProvided,
          '#options': whetherOrsProvidedOptions,
        },
        weatherChildIsReffered:{
          ...prevState.weatherChildIsReffered,
          '#options': whetherchildreferredOptions,
          '#isDisabled':true
        },
        hivTest: {
          ...prevState.hivTest,
          '#options': hivScreeningOptions,
        },
        nacpRefferalFacility: {
          ...prevState.nacpRefferalFacility,
          '#options': nacpRefferalFacilityOptions,
        },
        whetherComplementaryFeedingStartedAt6months: {
          ...prevState.whetherComplementaryFeedingStartedAt6months,
          '#options': whetherComplementaryFeedingStartedOptions,
        },
        whetherComplementaryFeedingAdequatelyProvided:{
          ...prevState.whetherComplementaryFeedingAdequatelyProvided,
          '#options': whetherComplementaryFeedingAdequatelyProvidedOptions,
        },
        whetherBottleOfIfaProvided:{
          ...prevState.whetherBottleOfIfaProvided,
          '#options': whetherBottleOfIfaProvidedOptions,         
        }
      }));

      const getCurrOption = (item:any) => {
        switch (item){
          case hbycKey.RED_FLAG_SIGN: 
            return redFlagIssueForBabyOptions;
          case hbycKey.WEATHER_CHILD_IS_SICK: 
            return childIsSickOptions;
          case hbycKey.GROWTH_CHART_OF_MCP_CARD:
            return getColorZoneOfBabyOptions;
          case hbycKey.WEATHER_CHILD_IS_REFERRED: 
            return whetherchildreferredOptions;
          case hbycKey.BREASTFEEDING_CONTINUE:
            return breastfeedingContinuedOptions;
          case hbycKey.SYPHILIS_TEST: 
            return syphilisTestOptions;
          case hbycKey.HIV_TEST:
            return hivScreeningOptions;
          case hbycKey.NACP_REFERRAL_FACILITY:
            return nacpRefferalFacilityOptions;
          case hbycKey.WHETHER_BOTTLE_OF_IFA_PROVIDED: 
            return whetherBottleOfIfaProvidedOptions;
          case hbycKey.WHETHER_ORS_PROVIDED: 
            return whetherOrsProvidedOptions;
          case hbycKey.WHETHER_COMPLEMENTARY_FEEDING_STARTED_AT_6_MONTHS:
            return whetherComplementaryFeedingStartedOptions;
          case hbycKey.WHETHER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED:
            return whetherComplementaryFeedingAdequatelyProvidedOptions;
            default:
              break;
        }
      }

      childHybcObj && Object.keys(childHybcObj).forEach((item:any) => {
        const option = getCurrOption(item);
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          [item]: {
            ...prevState[item],
            option: option,
          },
        }));
      });
      await getBackDatedEntry();
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
    finally{
      setLoader(false);
    }
  };

  const constructAndSetBackDatedData = async (data: any, childGrowthInfoData: any, shouldDisableWeightLength: boolean = true) => {
    const initialState = {
      weightOfBaby: { value: null, id: '', isApplicable: false },
      lengthOfBaby: { value: null, isApplicable: false },
      growthChartOfMcpCard: { value: null, isApplicable: false },
      redFlagSign: { value: null, id: '', isApplicable: false },
      weatherChildIsSick: { value: null, id: '', isApplicable: false },
      weatherChildIsReffered: { value: null, id: '', isApplicable: false },
      breastfeedingContinue: { value: null, id: '', isApplicable: false },
      syphilisTest: { value: null, id: '', isApplicable: false },
      hivTest: { value: null, id: '', isApplicable: false },
      nacpRefferalFacility: { value: null, id: '', isApplicable: false },
      whetherOrsProvided: { value: null, id: '', isApplicable: false },
      whetherComplementaryFeedingStartedAt6months: { value: null, id: '', isApplicable: false },
      whetherComplementaryFeedingAdequatelyProvided: { value: null, id: '', isApplicable: false },
      whetherBottleOfIfaProvided: { value: null, id: '', isApplicable: false },
    };
    const wetherChildValues: any[] = [];
    const wetherChildIds: any[] = [];
    const wetherChildServiceId: any[] = [];
    const updatedFormState = data?.reduce((acc: any, item: any) => {
      switch (item.service_code) {
        case HBYC_API_DETAILS.WEIGHT_IN_KEY:
          acc.weightOfBaby.value =
            item.service_report;
          acc.weightOfBaby.id = item.service_id;
          acc.weightOfBaby.reportId = item.service_report_id;
          acc.weightOfBaby.isApplicable = true;
          break;
        case HBYC_API_DETAILS.HEIGHT_IN_KEY:
          acc.lengthOfBaby.value =
            item.service_report;
          acc.lengthOfBaby.id = item.service_id;
          acc.lengthOfBaby.reportId = item.service_report_id;
          acc.lengthOfBaby.isApplicable = true;
          break;
        case HBYC_API_DETAILS.RED_FLAG_SIGN_KEY:
          acc.redFlagSign.value =
            item.service_report || item.red_flag_issue_for_baby_code;
          acc.redFlagSign.id = item.red_flag_issue_for_baby_id;
          acc.redFlagSign.serviceId = item.red_flag_issue_for_baby_id;
          acc.redFlagSign.reportId = item.red_flag_issue_for_baby_id;
          acc.redFlagSign.isApplicable = true;
          break;
        case HBYC_API_DETAILS.WHETHER_CHILD_IS_SICK_KEY:
          if (item.service_report) {
            wetherChildValues.push(
              item.service_report
            );
            wetherChildIds.push(item.service_report_id);
            wetherChildServiceId.push(item.service_id);
            acc.weatherChildIsSick.isApplicable = true;
          }
          break;

        case HBYC_API_DETAILS.WHETHER_CHILD_IS_REFERRED_KEY:
          acc.weatherChildIsReffered.value =
            item.service_report
          acc.weatherChildIsReffered.id = item.service_id;
          acc.weatherChildIsReffered.reportId = item.service_report_id;
          acc.weatherChildIsReffered.isApplicable = true;
          break;

        case HBYC_API_DETAILS.WHETHER_EXCLUSIVE_BREASTFEEDING_CONTINUED_KEY:
          acc.breastfeedingContinue.value =
            item.service_report
          acc.breastfeedingContinue.id = item.service_id;
          acc.breastfeedingContinue.reportId = item.service_report_id;
          acc.breastfeedingContinue.isApplicable = true;
          break;

        case HBYC_API_DETAILS.SYPHILIS_TEST_KEY:
          acc.syphilisTest.value =
            item.service_report
          acc.syphilisTest.id = item.service_id;
          acc.syphilisTest.reportId = item.service_report_id;
          acc.syphilisTest.isApplicable = true;
          break;

        case HBYC_API_DETAILS.HIV_TEST_KEY:
          acc.hivTest.value =
            item.service_report
          acc.hivTest.id = item.service_id;
          acc.hivTest.reportId = item.service_report_id;
          acc.hivTest.isApplicable = true;
          break;

        case HBYC_API_DETAILS.NACP_REFERRAL_FACILITY:
          acc.nacpRefferalFacility.value =
            item.service_report
          acc.nacpRefferalFacility.id = item.service_id;
          acc.nacpRefferalFacility.reportId = item.service_report_id;
          acc.nacpRefferalFacility.isApplicable = true;
          break;
        
        case HBYC_API_DETAILS.WHETHER_ORS_PROVIDED_KEY:
          acc.whetherOrsProvided.value =
            item.service_report
          acc.whetherOrsProvided.id = item.service_id;
          acc.whetherOrsProvided.reportId = item.service_report_id;
          acc.whetherOrsProvided.isApplicable = true;
          break;

          case HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_STARTED_KEY:
          acc.whetherComplementaryFeedingStartedAt6months.value =
            item.service_report
          acc.whetherComplementaryFeedingStartedAt6months.id = item.service_id;
          acc.whetherComplementaryFeedingStartedAt6months.reportId = item.service_report_id;
          acc.whetherComplementaryFeedingStartedAt6months.isApplicable = true;
          break;

          case HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED_KEY:
          acc.whetherComplementaryFeedingAdequatelyProvided.value =
            item.service_report
          acc.whetherComplementaryFeedingAdequatelyProvided.id = item.service_id;
          acc.whetherComplementaryFeedingAdequatelyProvided.reportId = item.service_report_id;
          acc.whetherComplementaryFeedingAdequatelyProvided.isApplicable = true;
          break;
          case HBYC_API_DETAILS.WHEATER_BOTTLE_OF_IFA_PROVIDED_KEY:
          acc.whetherBottleOfIfaProvided.value =
            item.service_report
          acc.whetherBottleOfIfaProvided.id = item.service_id;
          acc.whetherBottleOfIfaProvided.reportId = item.service_report_id;
          acc.whetherBottleOfIfaProvided.isApplicable = true;
          break;
        default:
          break;
      }
      return acc;
    }, initialState);

    const growthInfoArray = Array.isArray(childGrowthInfoData) ? childGrowthInfoData : (childGrowthInfoData ? [childGrowthInfoData] : []);
    const redFlagItems = growthInfoArray.filter((item: any) => item.red_flag_issue_for_baby_code || item.red_flag_issue_for_baby_id);
    if (redFlagItems.length > 0) {
      updatedFormState.redFlagSign = {
        value: redFlagItems.map((item: any) => item.red_flag_issue_for_baby_code),
        id: redFlagItems.map((item: any) => item.red_flag_issue_for_baby_id),
        serviceId: redFlagItems.map((item: any) => item.red_flag_issue_for_baby_id),
        reportId: redFlagItems.map((item: any) => item.red_flag_issue_for_baby_id),
        isApplicable: true
      };
    }
    const firstGrowthInfo = growthInfoArray[0];
    if (firstGrowthInfo?.growth_zone_colour_code) {
      updatedFormState.growthChartOfMcpCard = {
        value: firstGrowthInfo.growth_zone_colour_code,
        id: firstGrowthInfo.growth_zone_colour_id,
        serviceId: firstGrowthInfo.growth_zone_colour_id,
        isApplicable: true
      };
    }

    Object.keys(updatedFormState).forEach((item:any) => {
      if(item! =='weightOfBaby' || item !=='lengthOfBaby'){
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          weightOfBaby: {
            ...prevState.weightOfBaby,
            '#isDisabled': shouldDisableWeightLength,
          },
          lengthOfBaby:{
            ...prevState.lengthOfBaby,
            '#isDisabled': shouldDisableWeightLength,
          }
        }))
      }
      if(item !== 'weatherChildIsSick' && item !== 'growthChartOfMcpCard' && item!== 'redFlagSign') {
        updateFormStateIfApplicable(updatedFormState, item, updatedFormState[item]?.isApplicable)
      } else if(item === 'growthChartOfMcpCard'){
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          growthChartOfMcpCard: {
            ...prevState.growthChartOfMcpCard,
            value: firstGrowthInfo?.growth_zone_colour_name,
            id: firstGrowthInfo?.growth_zone_colour_id,
            serviceId: firstGrowthInfo?.growth_zone_colour_id,
            reportId: firstGrowthInfo?.growth_zone_colour_id,
          },
        }));
      }else if(item === 'redFlagSign'){
        if(updatedFormState['redFlagSign']?.isApplicable) {
          setChildHbycFormState((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              value: updatedFormState['redFlagSign']?.value,
              id: updatedFormState['redFlagSign']?.id,
              serviceId: updatedFormState['redFlagSign']?.serviceId,
              reportId: updatedFormState['redFlagSign']?.reportId,
            },
          }));
        }
      }
      else {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          weatherChildIsSick: {
            ...prevState.weatherChildIsSick,
            value: wetherChildValues,
            id: wetherChildServiceId,
            reportId: wetherChildIds,
          },
        }));
      }
    });

    updatedFormState['weatherChildIsSick']?.isApplicable && setChildHbycFormData((prevState: any) => ({
      ...prevState,
      weatherChildIsSick: {
        ...prevState.weatherChildIsSick,
        '#multiDropdown': !wetherChildValues.includes('No Sickness'),        
      },
    }));

    setBackDatedFormDetails((prev: any) => ({
      ...prev,
      weightOfBaby: {
        ...prev.weightOfBaby,
        value: updatedFormState.weightOfBaby?.value,
      },
      lengthOfBaby: {
        ...prev.lengthOfBaby,
        value: updatedFormState.lengthOfBaby?.value,
      },
      growthChartOfMcpCard: {
        ...prev.growthChartOfMcpCard,
        value: firstGrowthInfo?.growth_zone_colour_name ?? updatedFormState.growthChartOfMcpCard?.value,
      },
      redFlagSign: {
        ...prev.redFlagSign,
        value: updatedFormState.redFlagSign?.value,
      },
      weatherChildIsSick: {
        ...prev.weatherChildIsSick,
        value: wetherChildValues,
      },
      weatherChildIsReffered: {
        ...prev.weatherChildIsReffered,
        value: updatedFormState.weatherChildIsReffered?.value,
      },
      breastfeedingContinue: {
        ...prev.breastfeedingContinue,
        value: updatedFormState.breastfeedingContinue?.value,
      },
      syphilisTest: {
        ...prev.syphilisTest,
        value: updatedFormState.syphilisTest?.value,
      },
      hivTest: {
        ...prev.hivTest,
        value: updatedFormState.hivTest?.value,
      },
      nacpRefferalFacility: {
        ...prev.nacpRefferalFacility,
        value: updatedFormState.nacpRefferalFacility?.value,
      },
      whetherOrsProvided: {
        ...prev.whetherOrsProvided,
        value: updatedFormState.whetherOrsProvided?.value,
      },
      whetherComplementaryFeedingStartedAt6months: {
        ...prev.whetherComplementaryFeedingStartedAt6months,
        value: updatedFormState.whetherComplementaryFeedingStartedAt6months?.value,
      },
      whetherComplementaryFeedingAdequatelyProvided: {
        ...prev.whetherComplementaryFeedingAdequatelyProvided,
        value: updatedFormState.whetherComplementaryFeedingAdequatelyProvided?.value,
      },
      whetherBottleOfIfaProvided: {
        ...prev.whetherBottleOfIfaProvided,
        value: updatedFormState.whetherBottleOfIfaProvided?.value,
      },
    }));
  
  };

  const updateFormStateIfApplicable = (updatedFormState:any, key:any, isApplicable:boolean) => {    
    isApplicable && setChildHbycFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: updatedFormState[key].value,
        serviceId: updatedFormState[key].serviceId || updatedFormState[key].id,
        reportId: updatedFormState[key].reportId,
      },
    }));
  }

  useEffect(() => {
    initialFetch();
    return () => {
      dispatch(updateAncService('isEditButtonClicked', false));
    };
  }, []);

  useEffect(() => {
    setChildHbycFormData((prevState: any) => ({
    ...prevState,
    syphilisTest: {
      ...prevState.syphilisTest,
      '#required': motherSyphilisTest !== 'Non Reactive',
    },
    hivTest: {
      ...prevState.hivTest,
      '#required': currentHivTest !== 'Non-Reactive',
    },
  }));
  }, [currentHivTest, motherSyphilisTest]);

  const isValuePresent = (value:any) => {
		return Array.isArray(value) ? value.length < 1: !value;
	};

  const handleReferralField = (key: string, value: any) => {
    const toArray = (val: any) => Array.isArray(val) ? val : val ? [val] : [];

    let weatherChildIsSickValue: any[] = [];
    let redFlagSignValue: any[] = [];

    if (key === HBYC_COMMON_CONSTANTS.RED_FLAG_SIGN) {
      weatherChildIsSickValue = toArray(childHbycFormState.weatherChildIsSick?.value);
      redFlagSignValue = toArray(value);
    } else if (key === HBYC_COMMON_CONSTANTS.WHETHER_CHILD_IS_SICK) {
      redFlagSignValue = toArray(childHbycFormState.redFlagSign?.value);
      weatherChildIsSickValue = toArray(value);
    }

    weatherChildIsSickValue = weatherChildIsSickValue.filter(Boolean);
    redFlagSignValue = redFlagSignValue.filter(Boolean);

    const onlyNoSickness = weatherChildIsSickValue.length === 1 && weatherChildIsSickValue[0] === HBYC_COMMON_CONSTANTS.NO_SICKNESS;
    const onlyNoRedFlag = redFlagSignValue.length === 1 && redFlagSignValue[0] === HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN;
    const isEmpty = weatherChildIsSickValue.length === 0 && redFlagSignValue.length === 0;

    if (
      weatherChildIsSickValue.includes(HBYC_COMMON_CONSTANTS.NO_SICKNESS) &&
      (redFlagSignValue.includes(HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN) || redFlagSignValue.length === 0)
    ) {
      setChildHbycFormData((prevState: any) => ({
        ...prevState,
        weatherChildIsReffered: {
          ...prevState.weatherChildIsReffered,
          '#isDisabled': true,
        },
      }));
      clearWeatherChildIsReffered();
      return;
    }

    const shouldEnable =
      (!onlyNoSickness && weatherChildIsSickValue.length > 0) ||
      (!onlyNoRedFlag && redFlagSignValue.length > 0);
    
    const isFieldDisable = isEmpty ? true : !shouldEnable ? true : false; 
    setChildHbycFormData((prevState: any) => ({
      ...prevState,
      weatherChildIsReffered: {
        ...prevState.weatherChildIsReffered,
        '#isDisabled': isFieldDisable,
      },
    }));
    if (isFieldDisable) {
      clearWeatherChildIsReffered();
    }
  };

  const clearWeatherChildIsReffered = () => {
    setChildHbycFormState((prevState: any) => ({
      ...prevState,
      weatherChildIsReffered: {
        ...prevState.weatherChildIsReffered,
        value: '',
        id: '',
        reportId: '',
        isError: false,
        message: ''
      },
    }));
  };

  const handleChildHbycForm = (
    value: any,
    key: string,
    id: any,
    option: any,
    code: any,
    changedData: any
  ) => {
    if (key === hbycKey.WEIGHT_OF_BABY) {
      if (!/^(\d+(\.\d*)?|\.\d*|)$/.test(value)) {
        return;
      }
    } else if (key === hbycKey.LENGTH_OF_BABY) {
      if (value && (!checkIsDigit(value) || (parseFloat(value)===0 ? value.length > 2 : (value > 200) ? true : value.length > 6))) {
        return setChildHbycFormState((prevState: any) => ({
          ...prevState,
          lengthOfBaby: {
            ...prevState.lengthOfBaby,
            isError: true,
            message: child_hbyc_message.errorMessageforZeroLength,
          },
        }));
      } else if (value > 200 && value < 0) {
        return;
      }
    } else if (key === hbycKey.WEATHER_CHILD_IS_SICK && !isValuePresent(value)) {
      if (value?.includes('No Sickness')) {
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          weatherChildIsSick: {
            ...prevState.weatherChildIsSick,
            '#multiDropdown': false,
          },    
        }))
        let reportId;
        if (option) {
          const noneOption = option.find((data: any) => data.label === 'No Sickness');
          reportId = noneOption.reportId
        }
        else {
          reportId = id[0]
        }
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          weatherChildIsSick: {
            ...prevState.weatherChildIsSick,
            value: ['No Sickness'],
            reportId: [reportId],
            serviceId: id,
            isError: false,
            message: '',
            option: option,
          }
        }))
      }
      else {
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          weatherChildIsSick: {
            ...prevState.weatherChildIsSick,
            '#multiDropdown': true,
          },
        }))
        if (option) {
          id = [];
          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
            if (value?.includes(op.value)) {
              id.push(op.reportId);
            }
          });
          code = [];
          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
            if (value?.includes(op.value)) {
              code.push(op.code);
            }
          });
        }
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: Array.isArray(value) ? value : [value],
            serviceId: id,
            code: code,
            isError: false,
            reportId: id,
            message: '',
            option: option,
          },
        }));
      }
    } else if(key === hbycKey.WEATHER_CHILD_IS_SICK && isValuePresent(value)) {
      setChildHbycFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: '',
          id: id,
          code: code,
          isError: false,
          message: '',
        },
      }));
    } else if (key === hbycKey.RED_FLAG_SIGN) {
      if (!isValuePresent(value)) {
        if (value?.includes(HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN)) {
          setChildHbycFormData((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              '#multiDropdown': false,
            },    
          }));
          let serviceId;
          if (option) {
            const redFlagSign = option.find((data: any) => data.label === HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN);
            serviceId = redFlagSign.id
          } else {
            serviceId = id[0]
          }
          setChildHbycFormState((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              value: [HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN],
              serviceId: [serviceId],
              isError: false,
              message: '',
              option: option,
            }
          }))
        } else {
          setChildHbycFormData((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              '#multiDropdown': true,
            },
          }));
          if (option) {
            id = [];
            option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
              if (value?.includes(op.value)) {
                id.push(op.id);
              }
            });
            code = [];
            option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
              if (value?.includes(op.value)) {
                code.push(op.code);
              }
            });
          }
          setChildHbycFormState((prevState: any) => ({
            ...prevState,
            [key]: {
              ...prevState[key],
              value: Array.isArray(value) ? value : [value],
              serviceId: id,
              code: code,
              isError: false,
              message: '',
              option: option,
            },
          }));
        }
      } else {
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          redFlagSign: {
            ...prevState.redFlagSign,
            '#multiDropdown': true,
          },
        }));
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          [key]: {
            ...prevState[key],
            value: null,
            id: '',
            code: '',
            isError: false,
            message: '',
          },
        }));
      }
    }
    if (key === hbycKey.RED_FLAG_SIGN || key === hbycKey.WEATHER_CHILD_IS_SICK) {
      handleReferralField(key, ((key === hbycKey.RED_FLAG_SIGN) ? (value && value?.includes(HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN)) ? [HBYC_COMMON_CONSTANTS.NO_RED_FLAG_SIGN] : value : value));
    }
    let length: string;
    let weight: string;
    let colorCodeId: any;
    let response: string;
    if(key === hbycKey.WEIGHT_OF_BABY){
        weight = value ? (parseFloat(value) / 1000).toString() : value;
        length= childHbycFormState.lengthOfBaby.value;
        response = feildValidation(weight,length,childDetails.gender_name,whoGrowthData)
        colorCodeId = childHbycFormState.growthChartOfMcpCard?.option?.find((val:any) =>val.value ===  response)?.id
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          growthChartOfMcpCard:{
            ...prevState.growthChartOfMcpCard,
            value:response,
            serviceId: colorCodeId,
            isError: false,
            message: '',
          }
        }))
        
        if (response === color_codes.red) {
          setChildHbycFormData((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              '#isDisabled': false,
              '#required': true
            }
          }))
        } else {
          setChildHbycFormData((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              '#isDisabled': true,
              '#required': false
            }
          }))
          setChildHbycFormState((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              value: '',
              isError: false,
              message: '',
              id: '',
              serviceId: '',
              reportId: '',
            }
          }));
        }
    }
    
    if(key === hbycKey.LENGTH_OF_BABY){
      length =value;
      weight= childHbycFormState.weightOfBaby.value ? (parseFloat(childHbycFormState.weightOfBaby.value) / 1000).toString() : childHbycFormState.weightOfBaby.value;
      response = feildValidation(weight,length,childDetails.gender_name,whoGrowthData)
      colorCodeId = childHbycFormState.growthChartOfMcpCard?.option?.find((val:any) =>val.value ===  response)?.id
      setChildHbycFormState((prevState: any) => ({
        ...prevState,
        growthChartOfMcpCard:{
          ...prevState.growthChartOfMcpCard,
          value:response,
          serviceId: colorCodeId,
          isError: false,
          message: '',
        }
      }))
      
      if (response === color_codes.red) {
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          redFlagSign: {
            ...prevState.redFlagSign,
            '#isDisabled': false,
            '#required': true
          }
        }))
      } else {
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          redFlagSign: {
            ...prevState.redFlagSign,
            '#isDisabled': true,
            '#required': false
          }
        }))
        setChildHbycFormState((prevState: any) => ({
            ...prevState,
            redFlagSign: {
              ...prevState.redFlagSign,
              value: '',
              isError: false,
              message: '',
              serviceId: '',
              id: '',
              reportId: '',
            }
          }));
      }
  }
    
    if(key === hbycKey.GROWTH_CHART_OF_MCP_CARD){
      if (value?.includes(color_codes.red)){
        setChildHbycFormData((prevState: any) => ({
          ...prevState,
          redFlagSign: {
            ...prevState.redFlagSign,
            '#isDisabled': false,
            '#required': true
          }
        }))
      }
    } 
    if(key !== hbycKey.WEATHER_CHILD_IS_SICK && key !== hbycKey.RED_FLAG_SIGN) {
      setChildHbycFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value ? value : '',
          option: option,
          isError: false,
          serviceId: id,
          reportId: changedData?.reportId,
          message: '',
        },
      }));
    }
    if(key === hbycKey.SYPHILIS_TEST || key === hbycKey.HIV_TEST){
      const syphilisValue = key === hbycKey.SYPHILIS_TEST ? value : childHbycFormState?.syphilisTest?.value;
      const hivValue = key === hbycKey.HIV_TEST ? value : childHbycFormState?.hivTest?.value;
      
    const shouldEnableReferral =
          hivValue === IS_TESTED_FOR_HIV_OPTIONS.REFERRED_TO_CONFIRMATORY_FACILITY ||
          syphilisValue === SYPHILIS_TEST_OPTIONS.REACTIVE;      

    setChildHbycFormData((prevDataState: any) => ({
      ...prevDataState,
      nacpRefferalFacility: {
        ...prevDataState.nacpRefferalFacility,
        '#isDisabled': !shouldEnableReferral,
        '#required': shouldEnableReferral,
      }
    }));  
    setChildHbycFormState((prevState:any)=>({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        serviceId: id,
        reportId: changedData?.reportId,
      },
      nacpRefferalFacility: {
        ...prevState.nacpRefferalFacility,
        value: shouldEnableReferral ? prevState.nacpRefferalFacility.value : '',
        serviceId: shouldEnableReferral ? prevState.nacpRefferalFacility.serviceId : '',
        reportId: shouldEnableReferral ? prevState.nacpRefferalFacility.reportId : '',
        isError: false,
        message: '',
      }
    }))
    
    }
  };

  const isFormChanged = (childHbycFormState: any) => {
    const baseObject = backDatedResponse.length > 0 ? backDatedFormDetails : childHybcObj;
    for (const key in childHybcObj) {
      if (childHbycFormState[key].value !== baseObject[key].value) {
        return true;
      }
    }
    return false;
  };


  const handleSubmit = async () => {
    try {
      setLoader(true);
      let checkError = false;
      if (!childHbycFormState.weightOfBaby.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          weightOfBaby: {
            ...prevState.weightOfBaby,
            isError: true,
            message: child_hbyc_message.errorMessageWeightOfBaby,
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.weightOfBaby.value<500) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          weightOfBaby: {
            ...prevState.weightOfBaby,
            isError: true,
            message: child_hbyc_message.errorMessageForLessWeightOfBaby,
          },
        }));
        checkError = true;
      }
      if (!childHbycFormState.lengthOfBaby.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          lengthOfBaby: {
            ...prevState.lengthOfBaby,
            isError: true,
            message: child_hbyc_message.errorMessageLengthOfBaby,
          },
        }));
        checkError = true;
      }
      if (!childHbycFormState.growthChartOfMcpCard.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          growthChartOfMcpCard: {
            ...prevState.growthChartOfMcpCard,
            isError: true,
            message: child_hbyc_message.errorMessageforZoneDetails,
          },
          redFlagSign: {
            ...prevState.redFlagSign,
            isError: false,
            message: '',
          }
        }));
        checkError = true;
      } 
      if (childHbycFormState.growthChartOfMcpCard.value && (childHbycFormState.growthChartOfMcpCard.value === color_codes.red) && (!childHbycFormState.redFlagSign.value || childHbycFormState.redFlagSign.value?.length === 0)) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          redFlagSign: {
            ...prevState.redFlagSign,
            isError: true,
            message: child_hbyc_message.errorMessageRedFlagSign,
          },
          growthChartOfMcpCard: {
            ...prevState.growthChartOfMcpCard,
            isError: false,
            message: '',
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.hivTest && childHbycFormData.hivTest['#required'] &&  !childHbycFormState.hivTest.value) {
        setChildHbycFormState((prevState: any) => ({
         ...prevState,
        hivTest: {
          ...prevState.hivTest,
          isError: true,
          message: child_hbyc_message.errorMessageHivTest,
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.syphilisTest && childHbycFormData.syphilisTest['#required'] &&  !childHbycFormState.syphilisTest.value) {
        setChildHbycFormState((prevState: any) => ({
         ...prevState,
        syphilisTest: {
          ...prevState.syphilisTest,
          isError: true,
          message: child_hbyc_message.errorMessageSyphilisTest,
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.nacpRefferalFacility && childHbycFormData.nacpRefferalFacility['#required'] &&  !childHbycFormState.nacpRefferalFacility.value && childHbycFormData.nacpRefferalFacility['#isDisabled'] === false) {
        setChildHbycFormState((prevState: any) => ({
         ...prevState,
         nacpRefferalFacility: {
          ...prevState.nacpRefferalFacility,
          isError: true,
          message: child_hbyc_message.errorMessageNacpRefferalFacility,
          },
        }));
        checkError = true;
      }
      if (!childHbycFormData.weatherChildIsReffered['#isDisabled'] &&  !childHbycFormState.weatherChildIsReffered.value) {
        setChildHbycFormState((prevState: any) => ({
         ...prevState,
        weatherChildIsReffered: {
          ...prevState.weatherChildIsReffered,
          isError: true,
          message: child_hbyc_message.errorMessageWeatherChildIsReffered,
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.weatherChildIsSick && !childHbycFormState.weatherChildIsSick.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          weatherChildIsSick: {
            ...prevState.weatherChildIsSick,
            isError: true,
            message: child_hbyc_message.errorMessageChildIsSick,
          },
        }));
        checkError = true;
      }
      if (childHbycFormState.breastfeedingContinue && !childHbycFormState.breastfeedingContinue.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          breastfeedingContinue: {
            ...prevState.breastfeedingContinue,
            isError: true,
            message: child_hbyc_message.errorMessageBreastfeedingContinue,
          },
        }));
        checkError = true;
      }

      if (childHbycFormState.whetherBottleOfIfaProvided && !childHbycFormState.whetherBottleOfIfaProvided.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          whetherBottleOfIfaProvided: {
            ...prevState.whetherBottleOfIfaProvided,
            isError: true,
            message: child_hbyc_message.errorMessageWhetherBottleOfIfaProvided,
          },
        }));
        checkError = true;
      }

      if (childHbycFormState.whetherOrsProvided && !childHbycFormState.whetherOrsProvided.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          whetherOrsProvided: {
            ...prevState.whetherOrsProvided,
            isError: true,
            message: child_hbyc_message.errorMessageWhetherOrsProvided,
          },
        }));
        checkError = true;
      }

      if (childHbycFormState.whetherComplementaryFeedingStartedAt6months && !childHbycFormState.whetherComplementaryFeedingStartedAt6months.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          whetherComplementaryFeedingStartedAt6months: {
            ...prevState.whetherComplementaryFeedingStartedAt6months,
            isError: true,
            message: child_hbyc_message.errorMessageWhetherComplementaryFeedingStartedAt6months,
          },
        }));
        checkError = true;
      }

      if (childHbycFormState.whetherComplementaryFeedingAdequatelyProvided && !childHbycFormState.whetherComplementaryFeedingAdequatelyProvided.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          whetherComplementaryFeedingAdequatelyProvided: {
            ...prevState.whetherComplementaryFeedingAdequatelyProvided,
            isError: true,
            message: child_hbyc_message.errorMessageWhetherComplementaryFeedingAdequatelyProvided,
          },
        }));
        checkError = true;
      }

      if (childHbycFormState.whetherChildIsReffered && !childHbycFormState.whetherChildIsReffered.value) {
        setChildHbycFormState((prevState: any) => ({
          ...prevState,
          whetherChildIsReffered: {
            ...prevState.whetherChildIsReffered,
            isError: true,
            message: child_hbyc_message.errorMessageWhetherChildIsReffered,
          },
        }));
        checkError = true;
      }

      if (!checkError) {
        const childHbycPayload = {
          benfId: childDetails?.benef_id,
          facilityId: backDatedResponse.length ? backDatedResponse?.[0]?.facility_id : currentFacilityDetails?.facilityId,
          healthProviderId:  backDatedResponse.length ? backDatedResponse?.[0]?.healthprovider_id : currentFacilityDetails?.healthProviderId,
          mobiliserId:  backDatedResponse.length ? backDatedResponse?.[0]?.mobiliser_id : currentFacilityDetails?.mobilizerId,
          sessionId: vhndDetails?.sessionId || null,
          vhndExecutionId: vhndDetails?.executionId || null,
          hbycNo: hbycOngoingMetaData[0]?.hbyc,
          hbycVisitDate: FormatDate(visitDateUsed),
          weightOfBabyServiceId: weightOfBabyServiceId || null,
          weightOfBabyReportId: childHbycFormState?.weightOfBaby?.value || null,
          lengthOfBabyserviceId: lengthOfBabyServiceId || null,
          lengthOfBabyReportId: childHbycFormState?.lengthOfBaby?.value|| null,
          colourZoneOfBabyId: childHbycFormState?.growthChartOfMcpCard?.serviceId || null,
          redFlagIssueId: (childHbycFormState?.redFlagSign?.serviceId && childHbycFormState?.redFlagSign?.serviceId.length > 0) ? childHbycFormState?.redFlagSign?.serviceId : null,
          childSicknessServiceId: childHbycFormState?.weatherChildIsSick?.option[0]?.id,
          childSicknessReportId: childHbycFormState?.weatherChildIsSick?.reportId,
          whetherChildReferredServiceId: childHbycFormState?.weatherChildIsReffered?.serviceId,
          whetherChildReferredReportId: childHbycFormState?.weatherChildIsReffered?.reportId,          
          childReferredId: childHbycFormState?.weatherChildIsReffered?.reportId || null,
          exclusiveBreastFeedingContinueServiceId:
          childHbycFormState?.breastfeedingContinue?.serviceId|| null,
          exclusiveBreastFeedingContinueReportId: childHbycFormState?.breastfeedingContinue?.reportId,
          syphilisTestServiceId: childHbycFormState?.syphilisTest?.serviceId|| null,
          syphilisTestReportId: childHbycFormState?.syphilisTest?.reportId,
          hivTestServiceId: childHbycFormState?.hivTest?.serviceId|| null,
          hivTestReportId: childHbycFormState?.hivTest?.reportId,
          nacpReferralFacilityServiceId:childHbycFormState?.nacpRefferalFacility?.serviceId|| null,
          nacpReferralFacilityReportId:childHbycFormState?.nacpRefferalFacility?.reportId || null,
          orsProvidedServiceId: childHbycFormState?.whetherOrsProvided?.serviceId|| null,
          orsProvidedReportId: childHbycFormState?.whetherOrsProvided?.reportId,
          complementaryFeedingServiceId:null,
          complementaryFeedingReportId: null,
          complementaryFeedingStartedAt6monthsServiceId:childHbycFormState?.whetherComplementaryFeedingStartedAt6months?.serviceId|| null,
          complementaryFeedingStartedAt6monthsReportId: childHbycFormState?.whetherComplementaryFeedingStartedAt6months?.reportId,
          complementaryFeedingAdequatelyProvidedServiceId: childHbycFormState?.whetherComplementaryFeedingAdequatelyProvided?.serviceId|| null,
          complementaryFeedingAdequatelyProvidedReportId: childHbycFormState?.whetherComplementaryFeedingAdequatelyProvided?.reportId,
          bottleOfIfaProvidedServiceId: childHbycFormState?.whetherBottleOfIfaProvided?.serviceId|| null,
          bottleOfIfaProvidedReportId: childHbycFormState?.whetherBottleOfIfaProvided?.reportId,
          userId: localStorage.getItem('userId'),
          hbycServiceStartDt: FormatDate(hbycOngoingMetaData[0]?.startDate),
          hbycServiceEndDt: FormatDate(hbycOngoingMetaData[0]?.endDate),
        };
        
        await postDataJSON<any>(`${endpoints.addChildHbyc}`, childHbycPayload);
        const newFormCompleted = [true];
        setFormCompleted(newFormCompleted);
        setSelectedPerc(100);
        toast.success(CHILD_DETAILS.HBYC_SUCCESS_MSG(backDatedResponse.length), {
          position: 'top-center',
        });
        navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
      } else {
        const newFormCompleted = [false];
        setFormCompleted(newFormCompleted);
        setSelectedPerc(0);
        return;
      }
    } catch (error:any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
      finally {
        setLoader(false);
      }
  };

  const closeAlertModal = (value: boolean, title: any, action: any) => {
    if (value) {
      setAlertModalOpen(false);
      const serviceDetails = { currRoute: currentFacilityDetails?.currRoute };
      if (action === CHILD_DETAILS.BACK) {
        if (isEditButtonClicked) {
          navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
        } else {
          navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
        }
      } else {
        navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
      }
    } else {
      setAlertModalOpen(false);
    }
  };

  const contents = [
    <div key="Child HBYC Details">
       {loader? <Spinner /> :
      <form className="child-hbyc-form-container">
        <CommonFormFields
          formData={childHbycFormData}
          formState={childHbycFormState}
          handleFormChange={handleChildHbycForm}
        />
      </form>}
    </div>,
  ];

  const handleCancel = () => {
    setActionSource(CHILD_DETAILS.CANCEL);
    if (isFormChanged(childHbycFormState)) {
      setModalTitle(
        CHILD_DETAILS.MODAL_TITLE,
      );
      setAlertModalOpen(true);
      return;
    }
    setModalTitle(CHILD_DETAILS.MODAL_CLOSE);
    setAlertModalOpen(true);
  };

  const handleBack = () => {
    setActionSource(CHILD_DETAILS.BACK);
    if (isFormChanged(childHbycFormState)) {
      setModalTitle(
        CHILD_DETAILS.MODAL_TITLE,
      );
      setAlertModalOpen(true);
      return;
    }
    const serviceDetails = {
      currRoute: currentFacilityDetails?.currRoute,
    };
    if (isEditButtonClicked) {
      navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
    } else {
      navigateWithMenuItem('/beneficiaries/child/service-facility-details', 'Services', serviceDetails);
    } 
  }; 

  return (
    <>
      <ServiceOutline
        breadcrumbItemName={breadcrumbItemName}
        onHandleBackArrowButton={handleBack}
        navItemsModal={['Visit']}
        activeIndex={0}
        formCompleted={formCompleted}
        headerName={CHILD_DETAILS.HEADER_NAME}
        progressBarPerc={selectPerc}
        contents={contents}
        finishHandler={handleSubmit}
        handleCancel={handleCancel}
        title={getHbycTitle(hbycOngoingMetaData[0]?.hbyc)}
      />
      <AlertPopup
        showModal={alertModalOpen}
        closeModal={(value: boolean) =>
          closeAlertModal(value, modalTitle, actionSource)
        }
        title={modalTitle}
      />
    </>
  );
};

export default ChildHbyc;
